export default __webpack_public_path__ + "static/81490-7bd717034d2939ee3cc0a10f21c8a046.jpg";